/**************************************************
 * Nombre:       Dialogo_Politicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Collapse, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Suscripcion from "../Formularios/Formulario_Suscripcion";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useContext, useState} from "react";
import {theme} from "../../Tema";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {contexApp} from "../../App";
import {useNavigate} from "react-router";
import {useCopiarPortapapeles} from "../../Utilidades/useCopiarPortapapeles";
import {limpiarCelular} from "../../Modulo_formularios/Funciones/limpiarCelular";
import {crearCuponSuscriptores} from "../../CodCliente/crearCuponSuscriptores";

const Dialogo_Suscripcion = ({cerrar, realizado, datos}) => {
    const cData = useContext(contexApp)
    const navigate = useNavigate()
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {AvisoPortapapeles, copiarPortapapeles} = useCopiarPortapapeles()
    const {Cargador, Avisos, nuevoAviso, iniciarCarga, terminar, cerrarCarga} = useCargador({logoRedondo: logo})
    const [open, setOpen] = useState(false)


    let subirDatos = async () => {


        let entidad = await obtenerEntidad()
        entidad.correo = entidad.correo.toLowerCase()

        iniciarCarga('Generando cupón...')

        entidad.celular = limpiarCelular(entidad.celular)


        if (await verificarSiCelularInscrito(entidad.celular)) {
            terminar({aviso: 'El numero celular ya se encuentra suscrito, intenta con otro', variante: 'error'})
            return
        }


        let dox = await guardarDoc('suscriptores', entidad)
        if (dox.res) {
            await crearCuponSuscriptores({entidad: entidad})
            terminar({aviso: 'Exito, se ha enviado tu cupon mediante un mensaje de texto a tu numero celular'})
            setOpen(true)
        } else {
            terminar({aviso: 'Error al enviar, porfavor intentalo nuevamente', variante: 'error'})
        }


    }

    const verificarSiCelularInscrito = async (celular) => {

        let wheres = [where('celular', '==', celular)]
        let dox = await obtenerColWheres({col: 'suscriptores', wheres: wheres})

        return dox.res && dox.data.length > 0

    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}} sx={{px: 2}}>

            <Cargador/>

            <Avisos/>

            <AvisoPortapapeles/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{textAlign: 'center'}}>Estas aun un paso de lograrlo, completa los campos y disfruta de
                    los beneficios de ser parte
                    de la comunidad <span style={{fontWeight: 800}}>Amevi</span> </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                <Formulario_Suscripcion props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2, px: 1}}>
                <Typography sx={{fontSize: 14, lineHeight: 1.2}}>Se te enviará el codigo del cupon de descuento al
                    numero WhatsApp que ingreses</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                <Collapse in={open} sx={{width: '100%'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                            <Typography sx={{
                                lineHeight: 1.2,
                                color: theme.palette.primary.main,
                                fontSize: 32,
                                fontWeight: 800
                            }}>¡BIENVENIDA! </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                            <Typography sx={{lineHeight: 1.2, textAlign: 'center'}}>
                                Tu registro fue exitoso.
                                <br/>
                                <br/>
                                Has decidido ser parte de una comunidad de mujeres que se atreven a brillar, a sentirse
                                seguras, y a celebrar sus esencia en cada detalle.
                                Disfruta de <span style={{fontWeight: 800}}>10%OFF en tu primera compra</span>
                            </Typography>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                            <Typography sx={{lineHeight: 1.2, textAlign: 'center'}}>
                                Se ha enviado el codigo de cupon a tu WhatsApp
                            </Typography>
                        </Grid>


                    </Grid>


                </Collapse>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4, mb: 4}}>
                {open ?

                    <Button
                        onClick={() => {
                            cerrar();
                            navigate('/DetalleCol/' + cData.actColeccion.id)
                            if (realizado) {
                                realizado()
                            }

                        }
                        }
                    >Comprar Ahora</Button>
                    :
                    <Button
                        onClick={() => subirDatos()}
                    >Suscribirse</Button>

                }

            </Grid>

        </Grid>
    )

}
export default Dialogo_Suscripcion